/**
 * 工作台相关API接口
 */
import request from './utils/request'

/**
 * 查询企业业务员列表（分页）
 * @param {Object} params - 查询参数
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页数量
 * @returns {Promise} 业务员列表
 */
export function getSalesmanList(params) {
  return request({
    url: '/web/enterprise/getSalesmanList',
    method: 'get',
    params: params
  })
}

/**
 * 根据ID删除业务员
 * @param {number} id - 角色表组件id
 * @returns {Promise} 删除结果
 */
export function removeSalesmanById(id) {
  return request({
    url: '/web/enterprise/removeSalesmanById',
    method: 'post',
    data: id
  })
}

/**
 * 修改业务员状态
 * @param {Object} data - 业务员数据 { id, status }
 * @param {number} data.id - 角色表ID
 * @param {string} data.status - 状态：0-正常，1-停用
 * @returns {Promise} 修改结果
 */
export function editSalesmanStatus(data) {
  return request({
    url: '/web/enterprise/editSalesmanStatus',
    method: 'post',
    data: data
  })
}

/**
 * 业务员解绑操作
 * @returns {Promise} 解绑结果
 */
export function salesmanUnBundling() {
  return request({
    url: '/web/enterprise/salesmanUnBundling',
    method: 'post'
  })
}

/**
 * 查询用户列表（个人用户或企业用户）
 * @param {Object} params - 查询参数
 * @param {string} params.queryType - 查询类型：personal-个人用户, enterprise-企业用户
 * @param {string} params.userName - 用户名（个人用户）
 * @param {string} params.realName - 真实姓名（个人用户）
 * @param {string} params.phone - 手机号码（个人用户）
 * @param {string} params.loginAccount - 登录账号（企业用户）
 * @param {string} params.entName - 企业名称（企业用户）
 * @param {string} params.creditCode - 统一社会信用代码（企业用户）
 * @param {string} params.linkmanPhone - 联系人电话（企业用户）
 * @param {string} params.status - 状态
 * @param {number} params.pageNum - 页码
 * @param {number} params.pageSize - 每页数量
 * @returns {Promise} 用户列表
 */
export function getUserList(params) {
  return request({
    url: '/web/portal/portalSysProxyRelation/list',
    method: 'get',
    params: params
  })
}
/**
 * 移除客户
 * @param {number} id - 代理关系ID
 * @returns {Promise} 移除结果
 */
export function removeClient(id) {
  return request({
    url: '/web/portal/portalSysProxyRelation/removeClient',
    method: 'post',
    params: {
      id: id
    }
  })
}

/**
 * 取消用户授权代理
 * @param {number} id - 授权ID（代理关系ID）
 * @returns {Promise} 取消授权代理结果
 */
export function cancelCustomerAgency(id) {
  return request({
    url: '/web/portal/portalSysProxyRelation/cancelCustomerAgency',
    method: 'post',
    params: {
      id: id
    }
  })
}

/**
 * 分配客户给业务员（机构管理员）
 * @param {number} salesmanUserId - 业务员个人用户ID
 * @param {number[]} relationIds - 代理关系ID列表
 * @returns {Promise}
 */
export function assignClientsToSalesman(salesmanUserId, relationIds) {
  return request({
    url: '/web/portal/portalSysProxyRelation/assignClientsToSalesman',
    method: 'post',
    params: { salesmanUserId },
    data: relationIds
  })
}

/**
 * 取消业务员与客户的分配关系（机构管理员）
 * @param {number[]} relationIds - 代理关系ID列表
 * @returns {Promise}
 */
export function unassignClientsFromSalesman(relationIds) {
  return request({
    url: '/web/portal/portalSysProxyRelation/unassignClientsFromSalesman',
    method: 'post',
    data: relationIds
  })
}

/**
 * 查询当前企业的渠道码信息
 * @returns {Promise} 渠道码信息（包含渠道码和过期时间）
 */
export function getCurrentChannelCodeInfo() {
  return request({
    url: '/web/enterprise/getCurrentChannelCodeInfo',
    method: 'get'
  })
}

/**
 * 修改渠道码
 * @param {Object} data - 渠道码数据
 * @param {string} data.channelCode - 渠道码
 * @param {string} data.channelCodeExpireTime - 渠道码有效时间（可选）
 * @returns {Promise} 修改结果
 */
export function updateChannelCode(data) {
  return request({
    url: '/web/enterprise/updateChannelCode',
    method: 'post',
    data: data
  })
}

